module.exports = __webpack_public_path__ + "static/media/gassart.7b184117.jpg";